"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.33,0H.21V8.12H8.33ZM6.75,6.54h-5v-5h5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22,0H13.91V8.12H22ZM20.45,6.54h-5v-5h5Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M.21,21.82H8.33V13.7H.21Zm1.62-6.54h5v5H1.83Z",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.18",
    width: "1.9",
    height: "8.12",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "7.14",
    y: "10.92",
    width: "14.89",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "0.21",
    y: "9.09",
    width: "3.85",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10.65",
    y: "15.47",
    width: "2.13",
    height: "1.83",
    fill: "#004864"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "13.49",
    y: "13.7",
    width: "10.3",
    height: "10.3",
    fill: "#004864"
  }));
};

exports["default"] = _default;